import PropTypes from "prop-types";
import React from "react";

const Toolbar = props => {
  const { className, ...rest } = props;
  return <div className={`toolbar ${className ? className : ""}`} {...rest} />;
};

Toolbar.propTypes = {
  className: PropTypes.string,
};

export default Toolbar;



// WEBPACK FOOTER //
// ./casper/sass/components/toolbar/toolbar.js